export default __webpack_public_path__ + "static/media/paye_assessment_schedule_.234261b3.xlsx";